import 'react-dropzone-uploader/dist/styles.css';
import * as discoverInterfaces from '../../Interfaces/discover.interfaces';
import { Typography } from '@material-ui/core';
import { isEmpty } from '../../helpers/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import ImageSelectionAndCropper from "../Organisms/ImageSelectionAndCropper";

const useStyles = makeStyles((theme:any) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    dense: {
        marginTop: 19,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
        '& fieldset': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight:'none',
            borderBottomRightRadius:'0px',
            borderBottomLeftRadius:'0px'

        }
    },

    menu: {
        width: 200,
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    heading: {
        //Used for expansion panel
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

export const SimpleTextInput = ({
    helperText,
    handleChange,
    hook,
    key,
    label,
    multiline = false,
    name,
    required,
    type = 'text',
    value = ''
}: discoverInterfaces.IFieldTypeText) => {
    const classes = useStyles();

    return (
        <FormControl className={classes.formControl} error={!isEmpty(hook.errors[name])}>
            <TextField
                className={classes.textField}
                id={`text-field-${name}`}
                label={label}
                margin="normal"
                multiline={multiline}
                name={name}
                onChange={handleChange ?  handleChange : hook.handleChange}
                placeholder={`Enter your ${label} here`}
                required={required}
                rows={multiline ? 6 : 1}
                type={type}
                value={hook.values[name] || value}
            />
            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};

export const FieldTypeSelector = ({ hook, label, name, options }: discoverInterfaces.IFieldTypeSelector) => {
    const classes = useStyles();
    const inputLabel = React.useRef<HTMLLabelElement>(null);
    return (
        <FormControl className={classes.formControl} error={!isEmpty(hook.errors[name])} variant="outlined">
            <InputLabel htmlFor={`options-${name}`} ref={inputLabel}>
                {label}
            </InputLabel>
            <Select  id={`options-${name}`} name={name} onChange={hook.handleChange} value={hook.values[name] || ''}>
                {options.map((type: any, index: number) => (
                    <MenuItem key={index} value={type.value}>
                        {type.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};

export const FieldToggleSwitch = ({ hook, label, name, disabled }: discoverInterfaces.IFieldTypeToggle) => {
    return (
        <FormControlLabel
            control={
                <Switch
                    disabled={disabled}
                    checked={hook.values[name] === true}
                    inputProps={{ 'aria-label': label }}
                    name={name}
                    onChange={hook.handleChange}
                    value={true}
                />
            }
            label={label}
            labelPlacement="top"
        />
    );
};

export const TypeToggleFields = ({ hook, label, name, disabled}: any) => (
    <FieldToggleSwitch disabled={disabled} hook={hook} label={label} name={name} />
);


export const TypeNameFields = ({ hook }: any) => <SimpleTextInput hook={hook} label="name" name="name" />;
export const TypeMapFields = ({ hook, name }: any) => (
    <SimpleTextInput helperText="Please enter a valid address" hook={hook} label="Address goes here..." name={name} />
);

export const TypeScrollableTextFields = ({ hook }: any) => (
    <SimpleTextInput
        helperText="Please enter your text above"
        hook={hook}
        label="Text goes here..."
        multiline={true}
        name="scrollableText"
    />
);

export const TypeHTMLFields = ({ hook }: any) => (
    <React.Fragment>
        <SimpleTextInput
            helperText="Please enter your css above"
            hook={hook}
            label="CSS goes here..."
            multiline={true}
            name="css"
        />

        <SimpleTextInput
            helperText="Please enter your HTML above"
            hook={hook}
            label="HTML goes here..."
            multiline={true}
            name="html"
        />
    </React.Fragment>
);
export const TypeLinkFields = ({ hook }: any) => (
    <Grid item xs={12}>
        <SimpleTextInput helperText="Please enter a valid url" hook={hook} label="url" name="url" />
    </Grid>
);

export const TypeImageField = ({ fileType, helperText, hook, labels, name }: discoverInterfaces.IFieldTypeImage) => {
    const handleChangeStatus = async (field: string, obj: any) => {
        if (obj.status === 'done') {
            hook.handleChange({
                target: {
                    name: field,
                    value: obj.base64,
                },
            });
        }
        if (obj.status === 'removed') {
            hook.handleChange({
                target: {
                    name: field,
                    value: null,
                },
            });
            if (hook.triggerValidation) hook.triggerValidation();
        }
    };
    //Dynamically adjust aspect ratio to change with isSmallSize set
    const aspectRatio = hook.values.isSmallSize ? 1024/213 : 1024/426
    const recommendedWidth = 1024;
    const recommendedHeight = hook.values.isSmallSize ? 213 : 426;

    return (
        <FormControl error={!isEmpty(hook.errors[name])} style={{ width: '100%' }}>
            {isEmpty(hook.values[name]) && (
                <ImageSelectionAndCropper
                    aspectRatio={aspectRatio}
                    handleFileSelection={(base64:string)=>{
                                handleChangeStatus(name, {base64, status:'done'});
                    }}
                    recommended={{width:recommendedWidth, height:recommendedHeight}}/>
            )}
            {!isEmpty(hook.values[name])  && (
                <React.Fragment>
                    <Typography paragraph variant="body1">
                        Click "update" after removing the image to ensure it has been removed from the app.
                    </Typography>
                    <div style={{ width: 'max-content', margin: '0 auto', position: 'relative' }}>
                        <Icon
                            onClick={evt => {
                                evt.preventDefault();
                                hook.handleChange({
                                    target: {
                                        name,
                                        value: null,
                                    },
                                });
                            }}
                            style={{
                                zIndex: 1,
                                position: 'absolute',
                                transform: 'translate(50%, -50%)',
                                cursor: 'pointer',
                                top: 0,
                                right: 0,
                            }}
                        >
                            cancel
                        </Icon>
                        <img alt={`imageURL`} src={hook.values[name]} width="150" />
                    </div>
                </React.Fragment>
            )}

            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};
